import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-costo-envio',
  templateUrl: './costo-envio.component.html',
  styleUrls: ['./costo-envio.component.scss']
})
export class CostoEnvioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio/costo-envio.component.ts